module.exports = __webpack_public_path__ + "static/media/test13_2.92709398.png";